import { render, staticRenderFns } from "./AppCarousel.vue?vue&type=template&id=5c427546&scoped=true&"
import script from "./AppCarousel.vue?vue&type=script&lang=js&"
export * from "./AppCarousel.vue?vue&type=script&lang=js&"
import style0 from "./AppCarousel.vue?vue&type=style&index=0&id=5c427546&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c427546",
  null
  
)

export default component.exports